// @flow
import React, { Fragment, PureComponent } from 'react';
import { Link } from 'react-router-dom';

import { FFR_STRUCTURE_ORGANISATRICE_ID } from 'constants/competitionsConstants';
import type { CompetitionListElementType } from 'types/Competition';
import { dynamicClassName } from 'utils/dynamicClassName';
import { handleTagEvent }from 'utils/tagManagerUtils';
import { capitalizeFirstLetter } from 'utils/textUtils';

type Props = {
  title: string,
  championships: Array<CompetitionListElementType>,
  isOpen: boolean,
  ligue_id: number
};

type State = {
  isOpen: boolean
};

class CompetitionListRow extends PureComponent<Props, State> {
  props: Props;

  state: State = {
    isOpen: this.props.isOpen
  };

  static defaultProps = {
    title: '',
    championships: [],
    isOpen: false
  };

  handleHeaderClicked = (e: MouseEvent) => {
    e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  renderCompetitions = () => {
    const { ligue_id } = this.props;
    const classNameAccordion = dynamicClassName('accordion-panel');
    !this.state.isOpen && classNameAccordion.add('is-hidden');
    return (
      <ul className={classNameAccordion.build()}>
        <li className="list-competition__legend ft-h5 ">
          <span>Championnats</span>
        </li>
        {this.props.championships.sort(function(a, b) {
          let x = a.order;
          let y = b.order;
          return x < y ? -1 : x > y ? 1 : 0;
        }).map((championship, index) => {
          const classNameCount = dynamicClassName('');
          championship.recents > 0 && classNameCount.add('link-competition__count');

          const planner =  championship.StructureOrganisatrice.id !== FFR_STRUCTURE_ORGANISATRICE_ID && championship.StructureOrganisatrice.id !== ligue_id ? championship.StructureOrganisatrice.nom : '';

          return (
            <li key={index} className="list-competition__item">
              <Link
                className="link-competition"
                to={`/competitions/${championship.slug}`}
                title="TBD"
                onClick={
                  handleTagEvent('module competitions', `clic ${championship.division}`, window.location.pathname)
                }>
                <h3 className="link-competition__title ft-h4">{championship.division} {planner ? ` - organisé par la ligue ${capitalizeFirstLetter(planner)}` : ''}</h3>
                <span className={classNameCount.build()}>
                  {championship.recents > 0 ? 
                    `${championship.recents} nouveau(x) résultat(s)` : 
                    'Aucun nouveau résultat'
                  }
                </span>
              </Link>
              {championship.first.slug && 
              <Link
                className="list-competition__club"
                to={`/clubs/${championship.first.slug}`}
                title="TBD">
                {championship.first.src !== '' && <img src={championship.first.src} height="32" width="32" alt="TBD" />}
                {championship.first.title}
              </Link>}
            </li>
          );
        })}
      </ul>
    );
  };

  render() {
    const { title, championships } = this.props;

    const classNameHead = dynamicClassName('accordion-trigger list-competition__head');
    this.state.isOpen && classNameHead.add('is-selected');

    const championshipNumber = championships.length;

    return (
      <Fragment>
        <div className={classNameHead.build()} onClick={this.handleHeaderClicked} style={{cursor: 'pointer'}} role="button" tabIndex="0">
          <h2 className="ft-h3">{title}</h2>
          <div className="list-competition__count">
            {championshipNumber} championnat{championshipNumber > 1 ? 's' : ''}
            <span className="btn btn--icon " title="TBD">
              <i className="icon icon-zoom_plus " />
            </span>
          </div>
        </div>
        {this.renderCompetitions()}
      </Fragment>
    );
  }
}

export default CompetitionListRow;
